var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-card',[_vm._v(" Gz Kitap && Panel")]),_c('HomeChart'),_c('HomeStoreSales'),_c('HomeProductSales'),_c('HomeBrandSales'),_c('HomeStats')],1)}
var staticRenderFns = []

export { render, staticRenderFns }